import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .ant-form-item .ant-form-item-control-input {
    min-height: 32px;
  }

  .ant-form-vertical .ant-form-item-label {
    line-height: 1.5 !important;
  }
`;
